export default __webpack_public_path__ + "static/media/avatar.9ee81b1e.png";